import { ReplyItem } from './ReplyItem';

import type { CommentReply, CommentUserInfo } from '@/types/feedback';

interface PinPopoverRepliesSectionProps {
  replies: CommentReply[];
  commenterId?: string | null;
  commenterInfoMap?: Record<string, CommentUserInfo>;
  agencyName?: string;
  currentUserId?: string | null;
  isResolved?: boolean;
  onDeleteReply?: (replyIndex: number) => void;
}

export function PinPopoverRepliesSection({
  replies,
  commenterId,
  commenterInfoMap,
  agencyName,
  currentUserId,
  isResolved,
  onDeleteReply,
}: PinPopoverRepliesSectionProps) {
  if (replies.length === 0) return null;

  return (
    <div className={`border-t border-border pt-2 ${isResolved ? '' : 'pb-2'}`}>
      {replies.map((reply, i) => (
        <ReplyItem
          key={reply.localId ?? i}
          reply={reply}
          commenterId={commenterId}
          commenterInfoMap={commenterInfoMap}
          agencyName={agencyName}
          currentUserId={currentUserId}
          onDelete={onDeleteReply ? () => onDeleteReply(i) : undefined}
        />
      ))}
    </div>
  );
}
